import React, { useEffect, useMemo, useRef } from 'react';
import createObjectWithProperties from './createObjectWithProperties';

require('styles/react-data-grid/react-data-grid-header.css');

// The list of the propTypes that we want to include in the Draggable div
const knownDivPropertyKeys = ['onDragStart', 'onDragEnd', 'onDrag', 'style'];

const Draggable = (props: {
  onDragStart: (e: Event) => any;
  onDragEnd: (e: Event) => void;
  onDrag: (e: Event) => void;
  style: React.CSSProperties;
}) => {
  const { onDragStart = () => undefined, onDragEnd = () => {}, onDrag = () => {} } = props;

  const dragging = useRef<boolean>(false);

  useEffect(() => {
    //willUnmount
    return () => {
      cleanUp();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onMouseMove: Parameters<typeof window['addEventListener']>[1] = (e) => {
    if (!dragging.current) {
      return;
    }

    if (e.preventDefault) {
      e.preventDefault();
    }

    onDrag(e);
  };

  const onMouseUp: Parameters<typeof window['addEventListener']>[1] = (e) => {
    cleanUp();
    onDragEnd(e);
    dragging.current = false;
  };

  const onMouseDown: Parameters<typeof window['addEventListener']>[1] = (e) => {
    onDragStart(e);

    if (e.preventDefault) {
      e.preventDefault();
    }

    window.addEventListener('mouseup', onMouseUp);
    window.addEventListener('mousemove', onMouseMove);
    window.addEventListener('touchend', onMouseUp);
    window.addEventListener('touchmove', onMouseMove);
    dragging.current = true;
  };

  const cleanUp = () => {
    window.removeEventListener('mouseup', onMouseUp);
    window.removeEventListener('mousemove', onMouseMove);
    window.removeEventListener('touchend', onMouseUp);
    window.removeEventListener('touchmove', onMouseMove);
  };

  const knownDivProps = useMemo(() => {
    return createObjectWithProperties(props, knownDivPropertyKeys);
  }, [props]);

  return (
    <div
      {...knownDivProps}
      onMouseDown={onMouseDown}
      onTouchStart={onMouseDown}
      className="react-grid-HeaderCell__draggable"
    />
  );
};

export default Draggable;
